module.exports = __webpack_public_path__ + "img/img-a07a2a.png";